module.exports = __webpack_public_path__ + "img/ja.9fbddd48.svg";